import { __require as r } from "./td-longtail-vue-components273.js";
var a = r();
export {
  a as v
};
